const PENDING_PAYMENT_KEY = "infinium_pending_payment";

const getStorage = () => {
  if (typeof window === "undefined") {
    return null;
  }

  return window.sessionStorage;
};

export const storePendingPayment = ({ gateway, orderId, source }) => {
  const storage = getStorage();
  if (!storage || !gateway || !orderId) {
    return;
  }

  storage.setItem(
    PENDING_PAYMENT_KEY,
    JSON.stringify({
      gateway,
      orderId,
      source: source || "unknown",
      createdAt: Date.now(),
    })
  );
};

export const getPendingPayment = () => {
  const storage = getStorage();
  if (!storage) {
    return null;
  }

  const rawValue = storage.getItem(PENDING_PAYMENT_KEY);
  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(rawValue);
  } catch (error) {
    storage.removeItem(PENDING_PAYMENT_KEY);
    return null;
  }
};

export const clearPendingPayment = () => {
  const storage = getStorage();
  if (!storage) {
    return;
  }

  storage.removeItem(PENDING_PAYMENT_KEY);
};

export const hasMatchingPendingPayment = ({ gateway, orderId }) => {
  const pendingPayment = getPendingPayment();
  if (!pendingPayment) {
    return false;
  }

  return pendingPayment.gateway === gateway && pendingPayment.orderId === orderId;
};

export const getPayPalOrderIdFromApprovalUrl = (approvalUrl) => {
  if (!approvalUrl) {
    return "";
  }

  try {
    const url = new URL(approvalUrl);
    return url.searchParams.get("token") || "";
  } catch (error) {
    return "";
  }
};